import { Card } from "@/components/shadcn/card";

interface TableCardProps {
  children?: React.ReactNode;
}

export function TableCard ({ children }: TableCardProps) {
  return (
    <Card className="p-2 flex-1 flex flex-col gap-1">
      {children}
    </Card>
  );
}